import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { Lessonplan } from "../lesson-plan";

/**
 * Node-backed variant of the Lessonplan screen. Renders the exact same
 * component as the legacy /lessonplan page, but with `useNode` enabled so it
 * loads lesson plans / step statuses from the nodefork (Node) endpoints and
 * bypasses the IndexedDB cache. The Java /lessonplan page is left untouched.
 */
const LessonplanNode: React.FC<RouteComponentProps> = (props) => {
  return <Lessonplan {...props} useNode />;
};

export default LessonplanNode;
